interface Props {
  module: string;
}

export default function ComingSoon({ module }: Props) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md">
        <div className="text-4xl mb-4 text-slate-300">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-slate-700 mb-2">{module}</h2>
        <p className="text-slate-500 text-sm leading-relaxed">
          This module isn't enabled for your account yet.
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
}
